<script>
export default {
  props: {
    cheque: { type: Object },
  },
  data() {
    return {
      
    }
  },
}
</script>

<template>
<div class="cheque">
  <p>ID: {{ cheque.id }}</p>
  <p>Nome: {{ cheque.descricao }}</p>
  <p>Usuário: {{ cheque.user.name }}</p>
  <p>Ativo: <b-badge data-name="status" class="field-status" v-bind:variant="(cheque.status) ? 'success' : 'danger'">{{ (cheque.status) ? 'Sim' : 'Não' }}</b-badge></p>
  <p>Criado: <b-badge data-name="created_at" class="field-created_at" variant="secondary">{{ cheque.created_at }}</b-badge></p>
  <p>Última alteração: <b-badge data-name="updated_at" class="field-updated_at" variant="secondary">{{ cheque.updated_at }}</b-badge></p>
</div>
</template>